import React, { useState, useEffect } from "react";
import "./ai-sidebar.css";
import { PiArrowLeft, PiSparkleBold } from "react-icons/pi";

const SparkleIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2 L13.5 9 L20 10.5 L13.5 12 L12 19 L10.5 12 L4 10.5 L10.5 9 Z" />
    <path d="M19 2 L19.8 5.2 L23 6 L19.8 6.8 L19 10 L18.2 6.8 L15 6 L18.2 5.2 Z" />
    <path d="M5 15 L5.6 17.4 L8 18 L5.6 18.6 L5 21 L4.4 18.6 L2 18 L4.4 17.4 Z" />
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L3 6v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6l-9-4z" />
  </svg>
);

const AiSidebar = ({
  show, sideBarFun, nextPath, onNewChat,
  chatSessions = [], currentSessionId,
  onOpenSession, onLoadSessions, cleanTitle,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [recentOpen, setRecentOpen]   = useState(true);

  // Load sessions as soon as the bridge is ready (covers page refresh)
  useEffect(() => {
    if (onLoadSessions) onLoadSessions();
  }, [onLoadSessions]); // re-runs when bridge registers

  // Also reload when section is manually opened
  useEffect(() => {
    if (recentOpen && onLoadSessions) onLoadSessions();
  }, [recentOpen]); // eslint-disable-line

  const q = searchQuery.trim().toLowerCase();
  const filtered = q
    ? chatSessions.filter((s) => {
        const title = cleanTitle ? cleanTitle(s.title) : (s.title || "New Conversation");
        const preview = String(s.preview || "").toLowerCase();
        return title.toLowerCase().includes(q) || preview.includes(q);
      })
    : chatSessions;

  return (
    <div className={`ai-sidebar${show ? "" : " shrink"}`}>

      {/* Header */}
      <div className="ai-sidebar-header">
        <div className="ai-sidebar-icon">
          <PiSparkleBold />
        </div>
        <div className="ai-sidebar-title-wrap">
          <div className="ai-sidebar-title">Awareness Manager</div>
          <div className="ai-sidebar-subtitle">AI Awareness Manager</div>
        </div>
        <button
          className="ai-sidebar-collapse-btn"
          onClick={sideBarFun}
          title={show ? "Collapse sidebar" : "Expand sidebar"}
        >
          {show ? "❮" : "❯"}
        </button>
      </div>

      {/* Body */}
      <div className="ai-sidebar-body">

        {/* New Chat */}
        <button className="ai-new-chat-btn" title="New Chat" onClick={onNewChat}>
          <span className="ai-new-chat-plus">+</span>
          <span className="ai-new-chat-label">New Chat</span>
        </button>

        {/* Search */}
        <div className="ai-search-wrap">
          <span className="ai-search-icon">
            <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
          </span>
          <input
            className="ai-search-input"
            placeholder="Search conversations.."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Recent Chats */}
        <div
          className="ai-recent-header"
          onClick={() => setRecentOpen((o) => !o)}
        >
          <span className="ai-recent-title">Recent Chats</span>
          <span className={`ai-recent-arrow${recentOpen ? "" : " collapsed"}`}>&#8963;</span>
        </div>

        {recentOpen && (
          <div className="ai-recent-list">
            {filtered.length === 0 ? (
              <span className="ai-recent-empty">No conversations yet</span>
            ) : (
              filtered.map((session) => {
                const title = cleanTitle ? cleanTitle(session.title) : (session.title || "New Conversation");
                const isActive = session.sessionId === currentSessionId;
                return (
                  <div
                    key={session.sessionId}
                    className={`ai-chat-item${isActive ? " active" : ""}`}
                    onClick={() => onOpenSession && onOpenSession(session.sessionId)}
                    title={title}
                  >
                    {title}
                  </div>
                );
              })
            )}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="ai-sidebar-footer">
        <button
          className="ai-back-btn"
          onClick={() => nextPath && nextPath("/dashboard")}
          title="Back to TSAT"
        >
          <PiArrowLeft /><span className="ai-back-label"> Back to TSAT</span>
        </button>
      </div>

    </div>
  );
};

export default AiSidebar;
